<template>
  <div id="app">
    <Header15 />
    <router-view />
    <UtilsBar />
    <Footer15 />
  </div>
</template>
<script>
import Header15 from './components/Header15.vue';
import Footer15 from './components/Footer15.vue';
import UtilsBar from './components/UtilsBar.vue';
import Meta from '@/data/meta.json';
export default {
  /* eslint-disable */
  components: {
    Footer15,
    UtilsBar,
    Header15
  },
  computed: {
    isProdEnv() {
      const appUrl = this.appUrl(this.curLang);
      return appUrl.indexOf('www') >= 0 ? true : false;
    },
    isBetaEnv() {
      const appUrl = this.appUrl(this.curLang);
      return appUrl.includes("beta") ? true : false;
    }
  },
  methods: {
    // !! Todo: Move to store.
    appUrl(lang) {
      const frUrl = process.env.VUE_APP_URL_FR;
      const enUrl = process.env.VUE_APP_URL_EN;
      return lang === 'fr' ? frUrl : enUrl;
    }
  },
  data() {
    return {
      curLang: this.$store.getters.getAppLang,
      meta: Meta
    }
  },
  metaInfo() {
    const curLang = this.curLang;
    const appUrl = this.appUrl(curLang);
    const ogImage = `${appUrl}images/${this.meta.ogImage}`;
    // ***
    return {
      title: this.meta[curLang].title,
      htmlAttrs: { lang: curLang },
      meta: [
        { charset: 'utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'description', content: this.meta[curLang].description },
        { name: 'twitter:card', content: 'summary_large_image' },
        { property: 'og:title', content: this.meta[curLang].title },
        { property: 'og:description', content: this.meta[curLang].description },
        { property: 'og:image', content: ogImage },
        { property: 'og:url', content: appUrl }
      ],
      link: [
        { rel: 'mask-icon', color: '#00b74f', href: `${appUrl}images/cwm-sigil-vector-256-757281020.svg` },
        { rel: 'apple-touch-icon-precomposed', href: `${appUrl}images/cwm-apple-touch-icon-precompossed-158.png` },
        { rel: 'icon', href: `${appUrl}images/cwm-favicon-721281020.ico` },
        { rel: 'icon', sizes: '192x192', href: `${appUrl}images/cwm-sigil-192.png` }
      ],
      script: [
        { src: this.isProdEnv ? 'https://www.warmuseum.ca/headers/js/war_gtm.js' : this.isBetaEnv ? 'https://beta.warmuseum.ca/headers/js/war_gtm.js' : '' }
      ] 
    }
  }
};
</script>
<style lang="scss">
  @import 'assets/scss/main.scss';
</style>